import { deviceTypeOption } from "./const";


export const getDeviceType = (productCategory) => {
  const name = productCategory.toLowerCase();

  if (name === 'switch') {
    return deviceTypeOption.switch;
  } else if (name === 'access point') {
    return deviceTypeOption.ap;
  } else if (name === 'gateway') {
    return deviceTypeOption.gateway;
  } else {
    return deviceTypeOption.unknown;
  }
}


